import axios from "axios";
import webApi, { baseURL } from "../WebApi/WebApi";
import { toast } from "react-toastify";

//FOR LOGIN

export const getLogin = async (email, password, onSuccess, onFailure) => {
  // console.log(email, password, "login");

  try {
    const res = await webApi.post(`/auth/login`, {
      email: email,
      password: password,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");

      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    // console.log(error);
    // console.log("fdgdf...............");
  }
};

//FOR FORGOT PASSWORD
export const getForgetPassword = async (email, onSuccess, onFailure) => {
  // console.log(email, "login");

  try {
    const res = await webApi.post(`/auth/forgot-password`, {
      email: email,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

//FOR RESET PASSWORD
export const getResetPassword = async (
  password,
  token,
  onSuccess,
  onFailure
) => {
  // console.log(password, "login");

  try {
    const res = await webApi.post(`/auth/reset-password`, {
      password: password,
      token: token,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");

      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf", error);
    toast.error(error?.response?.data?.message);
  }
};

//FOR VERIFICATION EMAIL
export const getVerification = async (token, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/auth/verify-email`, {
      token: token,
    });
    if (res.status === 200) {
      const r = res.data;

      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

//FOR REGISTER
export const getRegistedr = async (register, onSuccess, onFailure) => {
  // console.log(register, "register");

  try {
    const res = await webApi.post(`/auth/register`, {
      register: register,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");

      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getRegister = async (data, onSuccess, onFailure) => {
  // console.log(data, "formData");
  try {
    const res = await webApi.post(`/auth/register`, data);
    console.log("res", res);
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.message
        ? error?.response?.data?.message
        : "Something went wrong"
    );
  }
};

//FOR RESEND EMAIL
export const getResend = async (email, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/auth/resend-verify-email`, {
      email: email,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");

      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};
